import React, { useId } from "react";
import { FormGroup, Input, Label } from "reactstrap";
export default function CheckBox(props) {
    const id = useId();
    return React.createElement(FormGroup, { check: true },
        React.createElement(Input, Object.assign({ id: props.id || id, type: props.type || "checkbox" }, props, { children: undefined, label: undefined })),
        React.createElement(Label, { check: true, for: props.id || id }, props.children || props.label));
}
